import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { contactInfo } from '../mockData';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Accueil' },
    { path: '/services', label: 'Services' },
    { path: '/devis', label: 'Devis' },
    { path: '/galerie', label: 'Galerie' },
    { path: '/a-propos', label: 'À Propos' },
    { path: '/contact', label: 'Contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          <img 
            src="https://customer-assets.emergentagent.com/job_ndvmotors/artifacts/4c93wpot_f1c1dc3fdad4c20d2af91de1fd3271d5efc3779d.png" 
            alt="NDV Motors Logo" 
            className="navbar-logo"
          />
        </Link>

        {/* Desktop Navigation */}
        <div className="navbar-links">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link ${isActive(link.path) ? 'active' : ''}`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <a href={`tel:${contactInfo.phone.replace(/\s/g, '')}`} className="navbar-cta">
          <Phone size={18} />
          <span>{contactInfo.phone}</span>
        </a>

        {/* Mobile Menu Button */}
        <button
          className="mobile-menu-btn"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="mobile-menu">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`mobile-nav-link ${isActive(link.path) ? 'active' : ''}`}
              onClick={() => setIsOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          <a
            href={`tel:${contactInfo.phone.replace(/\s/g, '')}`}
            className="mobile-phone-link"
          >
            <Phone size={18} />
            {contactInfo.phone}
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
